import AproveDisaproveActionBtn from "./AproveDisaproveActionBtn";
import GeneralInfo from "./GeneralInfo/GeneralInfoPresenter";
import CancelBtnUser, { ModifySpendingDemandBtnUser, SetPayedBtnUser, CloseSpendingDemandBtnUser, CreateSpendingFromSpendingDemandBtnUser, CreateCreditFromSpendingDemandBtnUser, ActionComptaUser, ActionUser, ActionBtnSpending } from "./ActionBtnUser/ActionBtnUser";
import HistoricStatusPresenter from "./HistoricStatus/HistoricStatusPresenter";
import FilesList from "./Files/FilesList/FilesList";

export const SingleSpendingDemand = {
    GeneralInfo : GeneralInfo,
    AproveDisaproveActionBtn : AproveDisaproveActionBtn,
    HistoricStatut : HistoricStatusPresenter,
    CancelBtnUser : CancelBtnUser,
    ModifySpendingDemandBtnUser : ModifySpendingDemandBtnUser,
    SetPayedBtnUser : SetPayedBtnUser,
    CloseSpendingDemandBtnUser : CloseSpendingDemandBtnUser,
    CreateSpendingFromSpendingDemandBtnUser : CreateSpendingFromSpendingDemandBtnUser,
    CreateCreditFromSpendingDemandBtnUser : CreateCreditFromSpendingDemandBtnUser,
    ActionComptaUser : ActionComptaUser,
    ActionUser : ActionUser,
    FilesList : FilesList,
    ActionBtnSpending : ActionBtnSpending
}

export default SingleSpendingDemand